/**
 * The FEMA ICS 205 authoring card.
 *
 * The printed form is box 4, the radio channel table, followed by box 5,
 * special instructions. The channel table is the existing `IncidentComsTable`
 * with its filters, which owns its own saves; only box 5 takes part in the card
 * save.
 */

import type React from 'react';
import type { ReactNode } from 'react';

import FemaIncidentInfoCard from './FemaIncidentInfoCard';

export type Fema205CardProps = {
  /** The channel table and its filters, which save themselves. */
  channels: ReactNode;
  banner?: ReactNode;
  headerActions?: ReactNode;
};

export const Fema205Card: React.FC<Fema205CardProps> = ({
  channels,
  banner,
  headerActions,
}) => (
  <FemaIncidentInfoCard
    baseId="ICS_205"
    banner={banner}
    headerActions={headerActions}
    slots={{ channels }}
  />
);

export default Fema205Card;
